var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CardWrapper",
    {
      staticClass: "crypto-chart-widget",
      attrs: {
        title: _vm.i18n.crypto_chart_title(),
        "data-test-id": "crypto-chart-widget"
      }
    },
    [
      !_vm.balancesReady
        ? _c(
            "div",
            {
              staticClass: "crypto-chart-widget__loading",
              attrs: {
                "data-test-id": "crypto-chart-widget-loading",
                role: "status"
              }
            },
            [
              _c("md-progress-spinner", {
                attrs: {
                  "md-diameter": 40,
                  "md-stroke": 4,
                  "md-mode": "indeterminate"
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_loading()))])
            ],
            1
          )
        : _vm.allowedBalances.length
        ? _c("div", { staticClass: "crypto-chart-widget__container" }, [
            _c("div", { staticClass: "crypto-chart-widget__plot" }, [
              _c("canvas", {
                ref: "canvas",
                staticClass: "crypto-chart-widget__canvas",
                attrs: { "data-test-id": "crypto-chart-widget-canvas" }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "crypto-chart-widget__legend",
                attrs: { "data-test-id": "crypto-chart-widget-legend" }
              },
              _vm._l(_vm.legendItems, function(item) {
                return _c(
                  "button",
                  {
                    key: item.asset,
                    staticClass: "crypto-chart-widget__legend-item",
                    class: { "is-hidden": _vm.hiddenLegendItems[item.index] },
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.toggleSector(item.index)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "crypto-chart-widget__legend-color",
                      style: { backgroundColor: item.color }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.label))])
                  ]
                )
              }),
              0
            )
          ])
        : _c(
            "div",
            {
              staticClass: "crypto-chart-widget__empty",
              attrs: { "data-test-id": "crypto-chart-widget-empty" }
            },
            [
              _c(
                "md-icon",
                { attrs: { "data-test-id": "crypto-chart-widget-empty-icon" } },
                [_vm._v("\n      wallet\n    ")]
              ),
              _vm._v(" "),
              _c(
                "p",
                { attrs: { "data-test-id": "crypto-chart-widget-empty-msg" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.i18n.th_no_assets_in_your_wallet()) +
                      "\n    "
                  )
                ]
              )
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b062e3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b062e3c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/widgets/CryptoChart.vue
// module id = 0/Lf
// module chunks = 1